import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { BaseDivider } from 'reservations/base/components/BaseDivider';

interface BookingConfirmationDetailCardProps {
  header: string;
  hideDivider?: boolean;
  endAdornment?: React.ReactNode;
}

const BookingConfirmationDetailCard = ({
  children,
  header,
  hideDivider = false,
  endAdornment
}: React.PropsWithChildren<BookingConfirmationDetailCardProps>) => (
  <Box
    sx={{
      background: 'none',
      borderRadius: '4px',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      gap: '16px',
      margin: '8px 0 63px'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'end'
        }}
      >
        <Typography
          textTransform="uppercase"
          variant="h2"
          sx={{ maxWidth: '100%', wordWrap: 'break-word' }}
        >
          {header}
        </Typography>
        {endAdornment}
      </Box>
      {!hideDivider && <BaseDivider />}
    </Box>
    {children}
  </Box>
);

export default BookingConfirmationDetailCard;
